import axios from 'axios'

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL || 'http://localhost:8000',
  xsrfCookieName: 'csrftoken',
  xsrfHeaderName: 'X-CSRFToken',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})
api.interceptors.request.use((request) => {
  console.log('Starting Request', request)
  return request
})
api.interceptors.response.use((response) => {
  console.log('Response:', response)
  return response
})

export default api
